var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RefreshIcon',{staticClass:"mx-auto h-12 w-12 text-blue-400"}),_c('div',{staticClass:"text-center text-blue-400 font-bold text-sm tracking-wide uppercase"},[_vm._v("Loading")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }